var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerticalSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 7.33335L10.6673 12.1167L12.384 10.4L13.334 11.3334L10.0007 14.6667L6.66732 11.3334L7.61732 10.4L9.33398 12.1167L9.33399 7.33335L10.6673 7.33335ZM6.00065 1.33335L9.33399 4.66669L8.38398 5.60002L6.66732 3.88335L6.66732 8.66669L5.33398 8.66669L5.33399 3.88335L3.61732 5.60002L2.66732 4.66669L6.00065 1.33335Z",
    fill: "#212121"
  })));
}

export default __webpack_public_path__ + "media/147ce8ea.svg";
export { SvgVerticalSwap as ReactComponent };